<template>
  <div class="layout-container">
    <router-view />
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { usePlatformStore } from '@/stores/platform'

const platformStore = usePlatformStore()

onMounted(() => {
  platformStore.initialize()
})
</script>

<style scoped>
/* 布局容器 - 绝对定位防止闪烁 */
.layout-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>
